const bold = 'ExpensifyNeue-Regular, Segoe UI Emoji, Noto Color Emoji';

export default bold;
